import axios from "axios";

const baseURL = process.env.VUE_APP_API_URL;

const http = axios.create({
  baseURL,
  headers: { Accept: "application/json" },
  timeout: 60000, // 60s
});

export default http;
